module.exports = __webpack_public_path__ + "img/Unidad17-2.bbb746b7.png";